import { render } from "./WebOrderModal.vue?vue&type=template&id=6a6068c8&scoped=true"
import script from "./WebOrderModal.vue?vue&type=script&lang=js"
export * from "./WebOrderModal.vue?vue&type=script&lang=js"

import "./WebOrderModal.vue?vue&type=style&index=0&id=6a6068c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a6068c8"

export default script